import React, { useState, useEffect } from 'react';
import LandingPage from './landingPage';
import TermsPage from './terms';
import DeleteDataPage from './deletePage';

const App: React.FC = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Function to navigate programmatically
  const navigate = (path: string) => {
    window.history.pushState({}, '', path);
    setCurrentPath(path);
  };

  // Render based on current path
  switch (currentPath) {
    case '/terms':
      return <TermsPage/>;
    case '/deleteUserData':
      return <DeleteDataPage/>;
    case '/':
    default:
      return <LandingPage />;
  }
};

export default App;